import { fromJS, Map } from 'immutable';

import {
  STATUS_IDLE,
  STATUS_ERROR,
  STATUS_DOWNLOADING,
  STATUS_COMPLETE,
  STATUS_GRIDWALL_TIMEOUT,
  determineStatusByMessage
} from './constants';

import {
  setStatus,
  setType,
  toggleBanner,
  generateReport,
  requestReportStatus,
  requestReportStatusV2,
  downloadReport,
  addDownloadOption,
  removeDownloadOption,
  updateSelectOption
} from './actions';

export const defaultState = Map({
  status: STATUS_IDLE,
  showBanner: true,
  type: '',
  options: [],
  selections: {},
  exportId: '',
  statusCheckCount: 0,
  statusCheckErrorCount: 0,
  downloadId: '',
  downloadUrl: ''
});

export default function downloads(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case setStatus.type:
      return newState.withMutations(state => {
        state
          .set('status', action.payload)
          .set('type', action.payload === STATUS_IDLE ? '' : newState.get('type'))
          // Re-surface if not idle
          .set('showBanner', action.payload !== STATUS_IDLE);
      });
    case setType.type:
      return newState.set('type', action.payload);
    case toggleBanner.type:
      return newState.set('showBanner', !newState.get('showBanner'));

    case generateReport.event.start:
      return newState.withMutations(state => {
        state
          .set('status', STATUS_DOWNLOADING)
          .set('showBanner', true)
          .set('type', action.payload.title)
          .set('exportId', '')
          .set('statusCheckCount', 0)
          .set('statusCheckErrorCount', 0);
      });
    case generateReport.event.success:
      return newState.withMutations(state => {
        if (state.get('status') === STATUS_DOWNLOADING)
          state.set('showBanner', true).set('exportId', action.payload?.payload?.exportId || action.payload.id);
      });
    case generateReport.event.error: {
      return newState.withMutations(state => {
        if (state.get('status') === STATUS_DOWNLOADING) {
          state
            .set('status', determineStatusByMessage(action.payload.error.message))
            .set('showBanner', true)
            .set('exportId', '');
        }
      });
    }

    case requestReportStatusV2.event.success:
      return newState.withMutations(state => {
        const { reportStatus, downloadUrl } = action.payload;
        const isComplete = reportStatus === 'COMPLETE';
        const isFailed = reportStatus === 'FAILED';
        state
          .set('statusCheckCount', state.get('statusCheckCount') + 1)
          .set('status', isComplete ? STATUS_COMPLETE : state.get('status'));
        // --
        if (isComplete) {
          state.set('downloadUrl', downloadUrl).set('exportId', '');
        }
        if (isFailed){
          state.set('status', STATUS_ERROR).set('showBanner', true).set('exportId', '');
        }
      });

    case requestReportStatusV2.event.error:
      return newState.withMutations(state => {
        state
          .set('statusCheckCount', state.get('statusCheckCount') + 1)
          .set('statusCheckErrorCount', state.get('statusCheckErrorCount') + 1);
      });

    case requestReportStatus.event.success:
      return newState.withMutations(state => {
        const { jobStatus } = action.payload;
        const isComplete = jobStatus === 'Completed';
        state
          .set('statusCheckCount', state.get('statusCheckCount') + 1)
          .set('status', isComplete ? STATUS_COMPLETE : state.get('status'));
        // --
        if (isComplete) state.set('downloadId', state.get('exportId')).set('exportId', '');
      });

    case requestReportStatus.event.error:
      return newState.withMutations(state => {
        state
          .set('statusCheckCount', state.get('statusCheckCount') + 1)
          .set('statusCheckErrorCount', state.get('statusCheckErrorCount') + 1);
      });

    case downloadReport.event.start:
      return newState.withMutations(state => {
        state.set('status', STATUS_DOWNLOADING).set('downloadId', '');
      });
    case downloadReport.event.success:
      return newState.set('status', STATUS_COMPLETE);
    case downloadReport.event.error:
      return newState.withMutations(state => {
        state
          .set('status', determineStatusByMessage(action.payload.error.message))
          .set('showBanner', true)
          .set('exportId', '');
      });

    case addDownloadOption.type:
      return newState.set('options', [...new Set(newState.get('options').concat([action.payload]))]);
    case removeDownloadOption.type:
      return newState.set('options', newState.get('options').filter(option => option !== action.payload) || []);

    case updateSelectOption.type:
      return newState.set('selections', { ...newState.get('selections'), ...action.payload });

    default:
      return newState;
  }
}

export const status = state => state.downloads.get('status');
export const showBanner = state => state.downloads.get('showBanner');

export const isIdle = state => state.downloads.get('status') === STATUS_IDLE;
export const isError = state => {
  const currentStatus = state.downloads.get('status');
  return currentStatus === STATUS_ERROR || currentStatus === STATUS_GRIDWALL_TIMEOUT;
};
export const isDownloading = state => state.downloads.get('status') === STATUS_DOWNLOADING;
export const isComplete = state => state.downloads.get('status') === STATUS_COMPLETE;

export const type = state => state.downloads.get('type');
export const exportId = state => state.downloads.get('exportId');
export const downloadId = state => state.downloads.get('downloadId');
export const downloadUrl = state => state.downloads.get('downloadUrl');
export const options = state => state.downloads.get('options');
export const selections = state => state.downloads.get('selections');
